module.exports = window.wp.escapeHtml;